/* global document */
import React from 'react';

// Code split widgets
import SideCartWidget from 'cart/SideCartWidgetLoader';
import ClubJoinButtonWidget from 'club/ClubJoinButtonWidgetLoader';
import FormWidgetRoot from 'form/FormWidgetRoot';
import BuyButtonWidget from 'products/BuyButtonWidgetLoader';
import CollectionWidgetRoot from 'products/CollectionWidgetRoot';
import LoginFormWidget from 'profile/LoginFormWidget';
import LoginWidget from 'profile/LoginWidget';
import PersonalizationBlockWidgetRoot from 'profile/personalization/PersonalizationBlockWidgetRoot';
import SubscribeWidgetRoot from 'profile/subscribe/SubscribeWidgetRoot';
import AvailabilityWidgetRoot from 'reservation/AvailabilityWidgetRoot';

// Bundled widgets

const Widgets = () => {
  const buyButtonDivs = document.getElementsByClassName('c7-buy-product');
  const cart = document.getElementById('c7-cart');
  const login = document.getElementById('c7-account');
  const loginForm = document.getElementById('c7-login-form');
  const collectionDivs = document.getElementsByClassName(
    'c7-product-collection'
  );
  const personalizationDivs =
    document.getElementsByClassName('c7-personalization');
  const clubJoinButtonDivs = document.getElementsByClassName(
    'c7-club-join-button'
  );
  const subscribeFormDivs = document.getElementsByClassName('c7-subscribe');
  const formDivs = document.getElementsByClassName('c7-custom-form');
  const reservationTypeDivs = document.getElementsByClassName(
    'c7-reservation-availability'
  );

  const collections = [];
  [].forEach.call(collectionDivs, (p) => {
    if (p.getAttribute('data-collection-slug')) {
      collections.push({
        node: p,
        collectionSlug: p.getAttribute('data-collection-slug')
      });
    }
  });
  const personalizations = [];
  [].forEach.call(personalizationDivs, (node) => {
    if (node.getAttribute('data-block-code')) {
      personalizations.push({
        node,
        code: node.getAttribute('data-block-code')
      });
    }
  });
  const buyButtons = [];
  [].forEach.call(buyButtonDivs, (p) => {
    if (p.getAttribute('data-product-slug')) {
      buyButtons.push({
        node: p,
        productSlug: p.getAttribute('data-product-slug')
      });
    }
  });
  const reservationTypes = [];
  [].forEach.call(reservationTypeDivs, (p) => {
    if (p.getAttribute('data-reservation-type-slug')) {
      reservationTypes.push({
        node: p,
        reservationTypeSlug: p.getAttribute('data-reservation-type-slug')
      });
    }
  });

  const clubs = [];
  [].forEach.call(clubJoinButtonDivs, (club) => {
    clubs.push({
      node: club,
      slug: club.getAttribute('data-club-slug'),
      joinText: club.getAttribute('data-join-text'),
      editText: club.getAttribute('data-edit-text')
    });
  });
  const forms = [];
  [].forEach.call(formDivs, (form) => {
    forms.push({
      node: form,
      code: form.getAttribute('data-form-code')
    });
  });
  const subscribeForms = [];
  [].forEach.call(subscribeFormDivs, (node) => {
    if (!node.classList.contains('c7-subscribe-personalization')) {
      subscribeForms.push({
        node,
        hasNameField: node.getAttribute('data-has-name-field')
      });
    }
  });

  return (
    <>
      {reservationTypes.map((product, index) => (
        <AvailabilityWidgetRoot
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          node={product.node}
          reservationTypeSlug={product.reservationTypeSlug}
        />
      ))}
      {buyButtons.map((product, index) => (
        <BuyButtonWidget
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          node={product.node}
          slug={product.productSlug}
        />
      ))}
      {cart && <SideCartWidget />}
      {login && <LoginWidget />}
      {loginForm && (
        <LoginFormWidget
          redirectTo={loginForm.getAttribute('data-redirect-to')}
        />
      )}
      {collections.map((collection, index) => (
        <CollectionWidgetRoot
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          node={collection.node}
          slug={collection.collectionSlug}
        />
      ))}
      {personalizations.map((personalization, index) => (
        <PersonalizationBlockWidgetRoot
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          node={personalization.node}
          code={personalization.code}
        />
      ))}
      {clubs.map((club, index) => (
        <ClubJoinButtonWidget
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          node={club.node}
          slug={club.slug}
          joinText={club.joinText}
          editText={club.editText}
        />
      ))}
      {forms.map((form, index) => (
        <FormWidgetRoot
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          index={index}
          node={form.node}
          code={form.code}
        />
      ))}
      {subscribeForms.map((form, index) => (
        <SubscribeWidgetRoot
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          index={index}
          node={form.node}
          hasNameField={form?.hasNameField === 'true' || false}
          hasZipCode={form?.hasZipCode === 'true' || false}
        />
      ))}
    </>
  );
};

export default Widgets;
